import { Frame } from "@/models/frame";

export class Note extends Frame {
	name: string;
	text: string = "Text";
	readonly type: string;

	constructor(id: number, name?: string) {
		super(id);
		this.name = name || `note${this.id}`;
		this.type = "Note";
	}

	placeNewItem(
		top: number,
		left: number,
		workspaceEl: HTMLElement,
		width?: number,
		height?: number,
	) {
		const itemElement = super.createNewItem(top, left, width, height);

		itemElement.classList.add("eer-note");
		itemElement.textContent = this.text;

		// Append the note element to the workspace
		workspaceEl.appendChild(itemElement);

		const workspaceRect = workspaceEl.getBoundingClientRect();
		this.workspaceOverflowCheck(workspaceRect, itemElement);
		this.activeItemClear();
	}

	public changeText(text: string) {
		this.text = text;
		const layerElement = document.getElementById(`item-${this.id}`);
		if (layerElement) {
			layerElement.textContent = text;
		}
	}
}
